var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._g(_vm._b({staticClass:"tslc-text-field",attrs:{"disabled":_vm.disabled,"color":"#243674","outlined":"","placeholder":_vm.placeholder,"rules":_vm.rules}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }